// extracted by mini-css-extract-plugin
module.exports = {"tabLayoutLeft":"styles_tabLayoutLeft__2w5Ox","title":"styles_title__2cqRY","tabImg":"styles_tabImg__2N5C5","fakeButton":"styles_fakeButton__2tmZ2"};